import { Component, css, html, LitElement, property } from '@rxdi/lit-html';

import { facebook, github, google, terra, twitter } from './icons';

type Providers = 'github' | 'facebook' | 'twitter' | 'google' | 'terra';

/**
 * @customElement social-login-button
 */
@Component({
  selector: 'social-login-button',
  style: css`
    .container {
      border-radius: 5px;
      padding: 10px;
      cursor: pointer;
    }
    .container .icon {
      width: 45px;
    }
    .container .text {
      margin-left: 15px;
      margin-top: 13px;
    }
  `,
  template(this: SocialLoginButtonComponent) {
    return html`
      <div
        @pointerenter=${this.mouseEnter}
        @pointerleave=${this.mouseLeave}
        class="container"
        style="background-color:${this.bgColor}; display:flex; "
      >
        <div class="icon">${this.icons[this.type](this.color)}</div>
        <div class="text" style="color: ${this.textColor}">
          <slot></slot>
        </div>
      </div>
    `;
  },
})
export class SocialLoginButtonComponent extends LitElement {
  @property() color = '#333';
  @property() bgColor = '';
  @property() textColor = '#333';
  @property({ type: Boolean }) active: boolean;
  @property() type: Providers = 'github';

  icons = {
    facebook,
    github,
    twitter,
    google,
    terra,
  };

  OnInit() {
    if (this.active) {
      this.hover();
    }
  }

  hover() {
    this.color = '#222';
    this.bgColor = '#ffffff';
    this.textColor = '#222';
  }

  leave() {
    this.color = '#333';
    this.bgColor = '';
    this.textColor = '#333';
  }

  mouseEnter() {
    if (!this.active) {
      this.hover();
    }
  }

  mouseLeave() {
    if (!this.active) {
      this.leave();
    }
  }
}
